import DashboardLayout from '../../../shared/DashboardLayout';

const PrintInvoice = () => {
  return (
    <DashboardLayout>
      
    </DashboardLayout>
  )
}

export default PrintInvoice
